import { memo } from "react";
import { classNames } from "helpers";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { ReactSVG } from "react-svg";

const ContactRepresentativeRowChild: React.FC<TableRowChildProps> = ({ index, row, onRowClick }) => {
  const displayName = row.name || `${row.firstName ?? ""} ${row.lastName ?? ""}`.trim();
  const initials = `${(row.firstName ?? "").charAt(0).toUpperCase()}${(row.lastName ?? "").charAt(0).toUpperCase()}`;

  return (
    <tr
      onClick={() => onRowClick?.(row.personContactId)}
      className={classNames(
        "hover:bg-slate-100 cursor-pointer",
        index % 2 === 0 ? "bg-white" : "bg-slate-50"
      )}
    >
      <td className="px-4 py-2 text-sm text-slate-600">
        <div className="flex items-center gap-2">
          <TableIcon imageUrl={null} initials={initials} />
        </div>
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
          {displayName}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        <div className="flex flex-wrap gap-1">
          {row.groups?.map((g: any) => (
            <Badge key={g.id} text={g.name} variant="info" height="small" />
          ))}
        </div>
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.role}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.jobTitle}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.department}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.email && (
          <span
            onClick={(e) => { e.stopPropagation(); window.location.href = `mailto:${row.email}`; }}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/email.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.email}
          </span>
        )}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.phone && (
          <span
            onClick={(e) => { e.stopPropagation(); window.location.href = `tel:${row.phone}`; }}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/phone.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.phone}
          </span>
        )}
      </td>
      <td className="px-4 py-2 text-sm text-slate-500">
        {row.address && (
          <span className="inline-flex items-center gap-1.5 text-md font-medium truncate text-slate-600">
            <ReactSVG src="/media/icons/map.svg" className="w-4 h-4 stroke-slate-400 shrink-0" />
            {row.address}
          </span>
        )}
      </td>
    </tr>
  );
};

export default memo(ContactRepresentativeRowChild);
